import React, { useEffect, useState } from 'react'
import { ProfileStoreProvider, useProfileStore } from 'context/ProfileStore'
import { Route, Switch } from 'react-router-dom'
import PrivateRoute from 'routes/PrivateRoute'
import { CREATE_USER_PATH, EDIT_USER_PATH } from 'routes/constants.routes'
import NoMatch from 'pages/NoMatch/NoMatch'
import { PageContainer } from 'components/PageContainer'
import { Button, Divider, Grid, useMediaQuery } from '@material-ui/core'
import ProfileFields from 'pages/Profile/components/ProfileFields/ProfileFields'
import { AccessInTheSystem } from 'pages/Profile/components/AccessInTheSystem'
import { useTranslation } from 'react-i18next'
import {
  CheckCircleIcon,
  LockedIcon,
  UnlockedIcon,
  UserPlusIcon
} from 'asterX-UI/Icons'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Superset } from 'pages/Profile/components/Superset'
import LockUnlockUserModal from 'components/modals/LockUnlockUser.modal'
import { useRoutes } from 'hooks'

export const ProfileRoutes = () => {
  return (
    <ProfileStoreProvider>
      <Switch>
        <PrivateRoute exact path={CREATE_USER_PATH} component={Profile} />
        <PrivateRoute
          exact
          path={EDIT_USER_PATH + '/:id'}
          component={Profile}
          componentProps={{ isEdit: true }}
        />
        <Route path="*">
          <NoMatch />
        </Route>
      </Switch>
    </ProfileStoreProvider>
  )
}

const Profile = props => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'))
  const { profileStoreFunc, profileStore } = useProfileStore()
  const { goPrevPage } = useRoutes()
  const {
    isEdit = false,
    match: { params = {} }
  } = props
  const user = profileStore?.user
  const onChangeUser = profileStoreFunc.onChangeUser

  useEffect(() => {
    if (isEdit) profileStoreFunc.getInitDataEditUser(params.id)

    return () => {}
  }, [])

  const defaultProps = {
    isEdit,
    userId: params?.id || ''
  }

  return (
    <PageContainer>
      {profileStore.loadingInit ? (
        <LoaderBackdrop loading={profileStore.loadingInit} />
      ) : (
        <Grid
          container
          spacing={5}
          direction={'row'}
          justifyContent={'flex-start'}
        >
          <LoaderBackdrop loading={profileStore.loading} />
          <Grid item xs={12} md={12} xl={12} lg={12}>
            <ProfileFields {...defaultProps} />
          </Grid>
          <Grid item xs={12} md={12} xl={12} lg={12}>
            <AccessInTheSystem {...defaultProps} />
          </Grid>
          {isEdit && (
            <>
              <Grid item xs={12} md={12} xl={12} lg={12}>
                <Divider />
              </Grid>
              <Grid item xs={12} md={12} xl={12} lg={12}>
                <Superset />
              </Grid>
            </>
          )}
          <Grid item xs={12} md={12} xl={12} lg={12}>
            <Divider />
          </Grid>
          <Grid
            item
            container
            justifyContent={'flex-end'}
            xs={12}
            md={12}
            xl={12}
            lg={12}
            spacing={2}
          >
            {isMobile ? (
              <>
                {isEdit && (
                  <BlockButton t={t} user={user} onChange={onChangeUser} />
                )}
                <Grid item xs={4} sm={4} lg={'auto'} xl={'auto'}>
                  <Button variant={'outlined'} onClick={goPrevPage}>
                    {t('profilePage.cancel')}
                  </Button>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={4} sm={4} lg={'auto'} xl={'auto'}>
                  <Button variant={'outlined'} onClick={goPrevPage}>
                    {t('profilePage.cancel')}
                  </Button>
                </Grid>
                {isEdit && (
                  <BlockButton t={t} user={user} onChange={onChangeUser} />
                )}
              </>
            )}
            <Grid item xs={8} sm={8} lg={'auto'} xl={'auto'}>
              <Button
                variant={'contained'}
                color={'primary'}
                onClick={profileStoreFunc?.onSave}
              >
                {isEdit ? (
                  <CheckCircleIcon fontSize={'small'} />
                ) : (
                  <UserPlusIcon fontSize={'small'} />
                )}
                {isEdit
                  ? t('profilePage.saveChanges')
                  : t('profilePage.createNewUser')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </PageContainer>
  )
}
export default Profile

const BlockButton = ({ t, user, onChange }) => {
  const isActiveUser = user?.isActive
  const [lockUnlockUser, setLockUnlockUser] = useState(false)
  const handleOpen = () => setLockUnlockUser(prevState => !prevState)

  const onSave = (user, isActive) => {
    onChange('isActive', isActive)
    if (!isActive) {
      onChange('subdivision', '')
    }
    handleOpen()
  }
  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={'auto'}
      xl={'auto'}
      style={{ justifyContent: 'flex-end', display: 'flex' }}
    >
      <Button
        variant={'contained'}
        color={isActiveUser ? 'secondary' : 'primary'}
        onClick={handleOpen}
      >
        {isActiveUser ? (
          <LockedIcon fontSize={'small'} />
        ) : (
          <UnlockedIcon fontSize={'small'} />
        )}
        {isActiveUser ? t('profilePage.block') : t('profilePage.unblock')}
      </Button>
      {lockUnlockUser && (
        <LockUnlockUserModal
          open={lockUnlockUser}
          onClose={handleOpen}
          onSave={onSave}
          isActive={!isActiveUser}
          user={user}
        />
      )}
    </Grid>
  )
}
